export default __webpack_public_path__ + "static/realEgg-bf6e58ad5ed5f2fb19d3f244010f3692.png";